module.exports = __webpack_public_path__ + "img/4.37bf14d.png";